import React from 'react';
import { StyledIonIcon } from './JukeboxOfflineIcon.styled';
import jukeboxOfflineIcon from './jukebox-offline-icon.svg';

const JukeboxOfflineIcon = () => {
  return <StyledIonIcon src={jukeboxOfflineIcon} />;
};

export default JukeboxOfflineIcon;
